import { Component } from '@angular/core';

@Component({
	standalone: true,
	selector: 'app-table-footer',
	templateUrl: 'table-footer.component.html',
	styleUrls: ['table-footer.component.scss']
})
export class TableFooterComponent {}
